import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "antd";
import {
  SbButton,
  BUTTON_TYPE,
  ArrowLeftOutlined,
  ReloadOutlined,
} from "uiCore";

import {
  PageHeaderStyled,
  HeaderLeftStyled,
  HeaderRightStyled,
  HeadingRowStyled,
} from "styles/common.styles";

const { Title } = Typography;

const AdminPageHeader = ({
  title,
  backRoute = "/admin-setup",
  onBack,
  onRefresh,
  rightActions,
}) => {
  const navigate = useNavigate();

  const handleBack = onBack ?? (() => navigate(backRoute));

  return (
    <PageHeaderStyled>
      <HeaderLeftStyled>
        <HeadingRowStyled>
          <SbButton
            buttonType={BUTTON_TYPE.SECONDARY}
            icon={<ArrowLeftOutlined />}
            onClick={handleBack}
            aria-label="Back"
          />
          <Title level={5}>{title}</Title>
        </HeadingRowStyled>
      </HeaderLeftStyled>
      <HeaderRightStyled>
        {onRefresh && (
          <SbButton
            buttonType={BUTTON_TYPE.SECONDARY}
            icon={<ReloadOutlined />}
            onClick={onRefresh}
          >
            Refresh
          </SbButton>
        )}
        {rightActions}
      </HeaderRightStyled>
    </PageHeaderStyled>
  );
};

export default AdminPageHeader;
